import { Controller } from 'stimulus';

// Runs before ui--twin-turbo-modal-trigger#open, which appends a dialog on every click. A double
// click would leave two dialogs sharing the frame, form and submit ids, and the visible dialog's
// submit button would send the hidden form. Keep an open dialog, and drop one that is still
// loading or closing so the trigger replaces it.
// Remove once UI::TwinTurboModal's trigger guards against this itself.
export default class extends Controller {
  static values = {
    frame: String,
  };

  guard(event) {
    for (const frame of document.querySelectorAll(`turbo-frame#${CSS.escape(this.frameValue)}`)) {
      const dialog = frame.closest('dialog.ui--twin-turbo-modal');

      if (dialog?.open) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      dialog?.remove();
    }
  }
}
